export function initSmoothScroll() {
    return null
}

export function destroySmoothScroll() {
    return undefined
}

export function smoothScrollTo(target, options = {}) {
    const behavior = options.immediate ? 'auto' : 'smooth'

    if (typeof target === 'number') {
        window.scrollTo({ top: target, behavior })
        return
    }

    if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior })
    }
}
